import { render } from "./MiniMetodeStartPage.vue?vue&type=template&id=bcfce3fe"
import script from "./MiniMetodeStartPage.vue?vue&type=script&lang=js"
export * from "./MiniMetodeStartPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__